import { render, staticRenderFns } from "./OrderMovementDetails.vue?vue&type=template&id=17cd6d7f&scoped=true"
import script from "./OrderMovementDetails.vue?vue&type=script&lang=js"
export * from "./OrderMovementDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderMovementDetails.vue?vue&type=style&index=0&id=17cd6d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cd6d7f",
  null
  
)

export default component.exports